import React from "react";
import styled from "styled-components";

import {
  institutionsName,
  institutionsType,
} from "@/database/institutions.json";

import fixedPhone from "@/assets/homePage/fixedPhone.png";

const Div = styled.div`
  height: 4rem;
  background-color: #f5f5f5;
  display: flex;
  align-items: center;
  justify-content: center;

  .pageHeader-container {
    width: 120rem;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .header-title {
      color: #888888;
      font-size: 1.4rem;
    }

    .header-phong {
      display: flex;
      align-items: center;

      .phong-number {
        color: #888888;
        font-size: 1.6rem;
        margin-left: 0.5rem;
      }
    }
  }
`;

function PageHeader() {
  return (
    <Div>
      <div className="pageHeader-container">
        <div className="header-title">
          {`您好，欢迎来到${institutionsName + institutionsType}`}
        </div>
        {/* <div className="header-phong">
          <img src={fixedPhone} alt="fixed-phong" />
          <div className="phong-number">服务热线：0532-86953366</div>
        </div> */}
      </div>
    </Div>
  );
}

export default PageHeader;
